module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_7005.b4af8504.png";